import React, { Component } from 'react';


class PrintStats extends Component {
    render() {
        const trans = this.props.trans;
        const statsObj = this.props.statsObj;
        const pointsObj = this.props.pointsObj;
        let getTrans = this.props.getTrans;
        let statsKeys = [
            { key: 'oF', transKey: 'pcminutesPlayed' },
            { key: 'cS', transKey: 'pcCS' },
            { key: 'gA', transKey: 'pcGA' },
            { key: 'gC', transKey: 'pcGC' },
            { key: 'gS', transKey: 'pcGS' },
            { key: 'oG', transKey: 'pcOG' },
            { key: 'pC', transKey: 'pcPC' },
            { key: 'pE', transKey: 'pcPE' },
            { key: 'pM', transKey: 'pcPM' },
            { key: 'pS', transKey: 'pcPS' },
            { key: 'rC', transKey: 'pcRC' },
            { key: 'sS', transKey: 'pcSS' },
            { key: 'yC', transKey: 'pcYC' },
            // { key: 'bR', transKey: 'pcBR' },
            { key: 'gOB', transKey: 'pcGOB' },
            { key: 'mOM', transKey: 'pcMOM' },
        ];


        let StatsKeyFilter = statsKeys.filter(function (sk, index) {
            let keyStats = (!isNaN(statsObj[sk.key]) ? statsObj[sk.key] : 0);
            if (keyStats > 0) {
                return sk;
            }
            else {
                return false;
            }
        });

        let statsList = '';
        if (StatsKeyFilter.length > 0) {
            statsList = <div className="si-match__details">
                {
                    StatsKeyFilter.map(function (sk, index) {
                        let keyStats = !isNaN(statsObj[sk.key]) ? statsObj[sk.key] : 0;
                        let keyPoints = !isNaN(pointsObj[sk.key]) ? pointsObj[sk.key] : 0;
                        let pointClass = keyPoints < 0 ? 'si-match__col si-negative-pts' : 'si-match__col';
                        let rowClass = "si-match__row";
                        let textToshow = "";
                        let isManOfMatchAndOneWon = keyStats == 1 && sk.key == 'mOM';
                        let muktipleMoM = getTrans(trans, "momMulKey", "{{mom}} man of the matches");
                        if (sk.key == 'mOM') {
                            rowClass = "si-match__row si-momw";
                            textToshow = isManOfMatchAndOneWon ? getTrans(trans, sk.transKey, sk.transKey) : muktipleMoM.replace('{{mom}}', keyPoints);
                            // if (isManOfMatchAndOneWon) {
                            //     keyStats = ""
                            //     keyPoints = ""
                            // }
                        }
                        return ((keyStats > 0) ? <div className={ rowClass } key={ sk.key }>
                            <span className="si-match__col">{ (sk.key == 'mOM' ? "" : keyStats) + " " + (textToshow ? textToshow : getTrans(trans, sk.transKey, sk.transKey)) }</span>
                            <div className={ pointClass }>
                                <span className="si-font--bold">{ keyPoints }</span>
                                &nbsp;{ getTrans(trans, "labelPts", "pts") }
                            </div>
                        </div> : '');
                    })
                }
                { <div className="si-match__row">
                    <div className="si-match__col si-font--bold">
                        { getTrans(trans, "TPoints", "Total Pts") + " " + pointsObj["tPoints"] }
                    </div>
                </div> }
            </div>
        } else {
            statsList = <div className="si-match__details">
                <div className={ "si-match__row" } key={ 1 }>
                    <span className="si-match__col">{ 0 + " " + getTrans(trans, 'pcminutesPlayed', 'minutesPlayed') }</span>
                    <div className={ 'si-match__col' }>
                        <span className="si-font--bold">{ 0 }</span>
                        &nbsp;{ getTrans(trans, "labelPts", "pts") }
                    </div>
                </div>
                <div className="si-match__row" style={ { "display": "none" } }>
                    <div className="si-match__col si-font--bold">
                        { getTrans(trans, "TPoints", "Total Pts") + " " + 0 }
                    </div>
                </div>
            </div>
        }
        return statsList;
    }
}

export default PrintStats;